<template>
  <v-tab-item>
    <v-container>
      <v-switch
        v-model="isUpload"
        :label="`ゲストの課題投稿を許可 ${message}`"
        @change="save"
      ></v-switch>
    </v-container>
  </v-tab-item>
</template>

<script>
/* eslint-disable no-console */
import { db } from "../../plugins/firebase";
import CommonMethods from "@/mixins/CommonMethods.js";
export default {
  mixins: [CommonMethods],
  props: {
    gymid: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isUpload: false,
      message: "しない",
    };
  },
  watch: {
    async gymid() {
      var result = await db
        .collection("M_GYM")
        .doc(this.gymid)
        .get();
      this.isUpload = result.data().unknown_upload;
      this.setMessage();
    },
  },
  mounted() {},
  methods: {
    save() {
      this.setMessage();
      this.update(
        "M_GYM",
        this.gymid,
        { unknown_upload: this.isUpload },
        { merge: true }
      );
    },
    setMessage() {
      if (this.isUpload) {
        this.message = "する";
      } else {
        this.message = "しない";
      }
    },
  },
};
</script>
